import { useTranslation } from "react-i18next";
import { GlobalService } from "../../../services/GlobalService";
import SearchIcon from "../../../layout/left_menu_icons/search_icon.svg";
import { React } from "react";

export default function Filters({
  setSearchCandidateResult,
  search,
  setSearch,
  setTotalPages,
  pageSize,
  totalPages,
  pageNumber
}) {
  let { t } = useTranslation();

  function searchCandidate() {
    GlobalService.SearchCandidate(pageSize, pageNumber, search).then((data) => {
      setTotalPages(Math.ceil(data.total / pageSize));
      setSearchCandidateResult(data.page);
    });
  }

  function onChange(event) {
    const value = event.target.value;
    setSearch({ ...search, [event.target.name]: value });
  }

  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={SearchIcon} alt="pc-icon" />
            <h1 style={{ marginTop: "10px" }}>{t("International Mobility")}</h1>
          </div>
          <div className="subtitle">
            {t("Recruitment / International Mobility")}
          </div>
        </div>
      </header>
      <div className="col-6 d-flex  mt-5">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            onChange={onChange}
            value={search.nameOrEmail || ""}
            name="nameOrEmail"
            placeholder="Search by Name or Email"
          ></input>
          <button
            className="btn btn-outline-secondary"
            onClick={searchCandidate}
            disabled={!search.nameOrEmail}
          >
            {t("search")}
          </button>
        </div>
      </div>
      <div className="col text-end" style={{ marginTop: "-44px" }}></div>
    </>
  );
}